import { createGalleryRow, delayedRowReset, fillDiscovery, getEvents } from "../../frameworks/mz-wp-api";
import { tns, TinySliderSettings, TinySliderInstance } from "tiny-slider";

import * as ReactDOM from "react-dom/client";

import GalleryPagination from "../global/galleryPagination";
import { wpFetch } from "../../main.top";

/** @returns {TinySliderSettings} */
export const discoverySliderOptions = function (sliderContainer) {
    return {
        container: sliderContainer,
        autoplay: false,
        controls: true,
        controlsPosition: "bottom",
        nav: false,
        items: 1,
        mouseDrag: true,
        loop: false,
        responsive: {
            1300: {
                items: 4,
            },
            768: {
                items: 3,
                fixedWidth: 301,
            },
        },
    };
};

/** @returns {TinySliderSettings} */
export const casesSliderOptions = function (sliderContainer) {
    return {
        container: sliderContainer,
        disable: true,
        autoplay: false,
        controls: true,
        controlsPosition: "bottom",
        nav: false,
        items: 5,
        mouseDrag: true,
        loop: false,
        responsive: {
            1300: {
                disable: false,
            },
        },
    };
};

const getContainer = (sectionClass) => document.querySelector(`.gallery.view > .${sectionClass} .container > .posts`);
const getPaginationContainer = (elementClass) => document.querySelector(`.gallery.view > .${elementClass} .container > .pagination`);

/**
 *
 * @param {Object} sectionObject
 * @param {Object} selectedTerms
 * @param {CallableFunction} nextPage
 * @param {CallableFunction} resetPage
 */
export const drawGallery = (sectionObject, selectedTerms = { categories: undefined, tags: undefined }, nextPage = false, resetPage = false) => {
    if (nextPage) {
        paginationDraw(sectionObject, true);
    }

    /**
     * A filter is set? Then update the request body.
     * A filter is NOT set? Then remove the parameter 'cat' from the request body.
     */
    // console.log("selectedTerms => ", selectedTerms);
    // console.log("sectionObject => ", sectionObject);
    if (selectedTerms.filtered) {
        sectionObject.reqBody["sectorsCategories"] = selectedTerms.sectorsCategories;
        sectionObject.reqBody["pagesAmount"] = undefined;
        sectionObject.reqBody["page"] = 1;
    } else if (!selectedTerms.filtered && nextPage === false && resetPage === false) {
        sectionObject.reqBody["pagesAmount"] = undefined;
        sectionObject.reqBody["page"] = 1;
        delete sectionObject.reqBody["sectorsCategories"];
    }

    if (selectedTerms.tag) {
        sectionObject.reqBody["tag"] = selectedTerms.tag;
        sectionObject.reqBody["pagesAmount"] = undefined;
        sectionObject.reqBody["page"] = 1;
    } else if (sectionObject.reqBody["tag"] && nextPage === false && resetPage === false) {
        sectionObject.reqBody["pagesAmount"] = undefined;
        sectionObject.reqBody["page"] = 1;
        delete sectionObject.reqBody["tag"];
    }

    // If is the first execution, then get the container
    const initialization = sectionObject.reqBody["pagesAmount"] === undefined;
    if (initialization) sectionObject.container = getContainer(sectionObject.containerClass);

    // If there is no pagination container, then get it.
    const paginationContainer = getPaginationContainer(sectionObject.containerClass);
    if (sectionObject.paginationRoot === undefined) sectionObject.paginationRoot = ReactDOM.createRoot(paginationContainer);

    // If the query changed, then update the pagination
    if (nextPage === false && resetPage === false) {
        let payload = structuredClone(sectionObject.reqBody);
        payload["pagesOnly"] = true;

        wpFetch("POST", ajaxurl, payload).then((res) => {
            res.json()
                .then((response) => {
                    sectionObject.reqBody["pagesAmount"] = response.pages;

                    paginationContainer.classList.toggle("disabled", !(sectionObject.reqBody["pagesAmount"] > 1));
                    paginationDraw(sectionObject, false);
                })
                .catch((err) => console.error(err));
        });
    }

    if (resetPage) {
        delayedRowReset(sectionObject.rows, 1);
        sectionObject.rows = [sectionObject.rows[0]];

        paginationDraw(sectionObject, false);
        return;
    }

    if (sectionObject.darkMode) {
        sectionObject.container.parentElement.parentElement.classList.add("dark");
    } else {
        sectionObject.container.parentElement.parentElement.classList.add("light");
    }

    getEvents(sectionObject.reqBody).then((res) => {
        if (res.posts.length === 0) {
            sectionObject.container.parentElement.parentElement.classList.add("empty");
            return;
        }
        // If the rows amount will get back to 1, then delete the other ones.
        if (sectionObject.rows.length > 0 && initialization) {
            delayedRowReset(sectionObject.rows, 0);
            sectionObject.rows = [];
        }

        // If is the first row or the enxt page, then create it.
        if (initialization || nextPage) {
            const newRow = createGalleryRow(sectionObject.container, "");
            const items = newRow.querySelector(".items");
            let slider = undefined;

            fillDiscovery(res, items);
            slider = tns(discoverySliderOptions(items));

            addRow(sectionObject, newRow, slider);

            // This class makes the row visible in a nice way.
            newRow.classList.add("ready");
        }

        sectionObject.container.parentElement.parentElement.classList.remove("empty");

        // Update the pagination
        paginationDraw(sectionObject, false);
    });
};

const resetPage = function (sectionObject) {
    sectionObject.reqBody["page"] = 1;
    sectionObject.init(undefined, false, true);
};

const nextPage = function (sectionObject) {
    const currentPage = sectionObject.reqBody["page"];
    const pages = sectionObject.reqBody["pagesAmount"];

    sectionObject.reqBody["page"] = currentPage + 1 <= pages ? currentPage + 1 : pages;
    sectionObject.init(undefined, true);
};

const addRow = function (sectionObject, rowElm, slider) {
    sectionObject.rows.push({ row: rowElm, slider: slider });
};

const paginationDraw = (sectionObject, loading) => {
    sectionObject.paginationRoot.render(
        <GalleryPagination
            page={sectionObject.reqBody["page"]}
            pages={sectionObject.reqBody["pagesAmount"]}
            toPage={(page) => resetPage(sectionObject, page)}
            nextPage={() => nextPage(sectionObject)}
            isLoading={loading}
        />
    );
};

const sections = {
    talks: {
        reqBody: {
            action: "getNews",
            status: "publish",
            page: 1,
            pagesAmount: undefined,
        },
        containerClass: "talks",
        container: undefined,
        /** @type {[{row: HTMLElement, slider: TinySliderInstance}]} */
        rows: [],
        paginationRoot: undefined,
        darkMode: false,
        init: function (selectedTerms, nextPage = false, resetPage = false) {
            drawGallery(this, selectedTerms, nextPage, resetPage);
        },
    },
    podcasts: {
        reqBody: {
            action: "getPodcasts",
            status: "publish",
            page: 1,
            pagesAmount: undefined,
        },
        containerClass: "podcasts",
        container: undefined,
        /** @type {[{row: HTMLElement, slider: TinySliderInstance}]} */
        rows: [],
        paginationRoot: undefined,
        darkMode: false,
        init: function (selectedTerms, nextPage = false, resetPage = false) {
            drawGallery(this, selectedTerms, nextPage, resetPage);
        },
    },
    pautas: {
        reqBody: {
            action: "getPautas",
            status: "publish",
            page: 1,
            pagesAmount: undefined,
        },
        containerClass: "pautas",
        container: undefined,
        /** @type {[{row: HTMLElement, slider: TinySliderInstance}]} */
        rows: [],
        paginationRoot: undefined,
        darkMode: false,
        init: function (selectedTerms, nextPage = false, resetPage = false) {
            drawGallery(this, selectedTerms, nextPage, resetPage);
        },
    },
};

export function renderDiscoveryGallery(termsList) {
    sections.talks.init(termsList);
    sections.podcasts.init(termsList);
    sections.pautas.init(termsList);
}
